import { useEffect } from 'react';

import { UNSAFE_noExposureExp } from '@confluence/feature-experiments';

import { useExperimentInfoActions } from '../../store/experimentInfoStore';
import { statsigCohorts } from '../../experimentConstants';

export const useLoadCohortToStore = () => {
	const { setCohort } = useExperimentInfoActions();
	const [expConfig] = UNSAFE_noExposureExp('confluence_end_of_trial_modal_switcheroo');
	const cohort = expConfig.get('cohort', statsigCohorts.NON_ENROLLED);

	useEffect(() => {
		void setCohort(cohort);
	}, [cohort, setCohort]);
};
